"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _addCallback(globalStateManager, callback) {
    return globalStateManager.addCallback(callback);
}
exports.default = _addCallback;
;
